<a class="boton" href="{{ url }}" target="_blank" rel="noopener"
  title="Contactar por WhatsApp">
  <fa-icon [icon]="icons.whatsapp" size="2x"></fa-icon>
  <span class="sr-only">Contactar por WhatsApp</span>
</a>